module.exports = __webpack_public_path__ + "img/hometop3.19bff0fd.jpg";